import produce from "immer";
import { CustomizationState } from "../";
import { findColorDefinition, findPageDefinition } from "../../../utils/customization/finders";

export interface ChangeAllPagesColorDefinitionAction {
  type: "changeAllPagesColorDefinition";
  colorDefinitionKey: string;
}

export function changeAllPagesColorDefinition(
  state: CustomizationState,
  action: ChangeAllPagesColorDefinitionAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { content, template } = draftState;
    const { colorDefinitionKey } = action;

    const colorDefinition = findColorDefinition(colorDefinitionKey, template.colorDefinitions);
    if (!colorDefinition) {
      // todo: add error message ?
      // throw new Error('colorDefinition for key ${colorDefinitionKey} not found');
      return;
    }

    draftState.ui.defaultColorKey = colorDefinitionKey;

    for (const page of content.pages) {
      const pageDefinition = findPageDefinition(page.pageDefinitionKey, draftState.template);
      if (pageDefinition.backgroundColorKeys.includes(colorDefinitionKey) === false) {
        continue;
      }

      page.backgroundColorKey = colorDefinition.key;
    }
  });
}
